import { colors } from "common/const/colors";
import { DefaultButton } from "./DefaultButton";
import {
  DeleteIcon,
  IconWrapper,
  MinusIcon,
  PlusIcon,
} from "common/components/icon";

export const DeleteButton = ({
  width = "3.25rem",
  height = "3.25rem",
  iconSize,
  onClick,
  disabled,
}) => {
  const color = disabled ? colors.Gray : colors.Red;
  return (
    <DefaultButton
      width={width}
      height={height}
      onClick={onClick}
      borderColor={color}>
      <IconWrapper size={iconSize}>
        <DeleteIcon color={color} />
      </IconWrapper>
    </DefaultButton>
  );
};

export const AddButton = ({
  width = "3.25rem",
  height = "3.25rem",
  iconSize,
  color,
  onClick,
  disabled,
}) => {
  const displayColor = color ?? (disabled ? colors.Gray : colors.MainBlue);

  return (
    <DefaultButton
      width={width}
      height={height}
      onClick={onClick}
      borderColor={displayColor}
      style={{ flexShrink: 0, background: colors.White }}
      disabled={disabled}>
      <IconWrapper size={iconSize}>
        <PlusIcon color={displayColor} />
      </IconWrapper>
    </DefaultButton>
  );
};

export const RemoveButton = ({
  width = "3.25rem",
  height = "3.25rem",
  iconSize,
  color,
  onClick,
  disabled,
}) => {
  const displayColor = color ?? (disabled ? colors.Gray : colors.MainBlue);

  return (
    <DefaultButton
      width={width}
      height={height}
      onClick={onClick}
      borderColor={displayColor}
      style={{ flexShrink: 0, background: colors.White }}
      disabled={disabled}>
      <IconWrapper size={iconSize}>
        <MinusIcon color={displayColor} />
      </IconWrapper>
    </DefaultButton>
  );
};
